// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2UjW8","label":"Completed_label__1GUjB"};